export default function AboutHero() {
  return (
    <div className="w-full bg-white py-16 md:py-20 lg:py-24 px-6 md:px-12 lg:px-16 xl:px-20">
      <div className="max-w-6xl mx-auto">
        {/* Main Container */}
        <div className="flex flex-col lg:flex-row items-center gap-6 md:gap-8 lg:gap-12">
          {/* Left Column - Content */}
          <div className="flex flex-col justify-center items-start gap-6 md:gap-8 flex-1 w-full">
            {/* Heading Section */}
            <div className="flex flex-col items-start gap-2 w-full relative">
              <h1 className="text-primary text-2xl md:text-3xl lg:text-4xl font-semibold leading-[150%] w-full">
                Our Journey
              </h1>
              <p className="text-black text-sm md:text-base font-medium leading-[150%] w-full">
                Our story is one of continuous growth and evolution. We started as a small team with big dreams, determined to create a real estate platform that transcended the ordinary.
              </p>
            </div>

            {/* Stats Cards Container */}
            <div className="flex flex-col sm:flex-row items-stretch gap-4 w-full">
              {/* Card 1 */}
              <div className="flex flex-col items-start gap-0.5 flex-1 p-4 md:p-5 border border-gray-200 bg-tertiary">
                <div className="text-black text-xl md:text-2xl font-bold leading-[150%] w-full">
                  200+
                </div>
                <div className="text-black/80 text-xs md:text-sm font-medium leading-[150%] w-full">
                  Happy Customers
                </div>
              </div>

              {/* Card 2 */}
              <div className="flex flex-col items-start gap-0.5 flex-1 p-4 md:p-5 border border-gray-200 bg-tertiary">
                <div className="text-black text-xl md:text-2xl font-bold leading-[150%] w-full">
                  10k+
                </div>
                <div className="text-black/80 text-xs md:text-sm font-medium leading-[150%] w-full">
                  Properties For Clients
                </div>
              </div>

              {/* Card 3 */}
              <div className="flex flex-col items-start gap-0.5 flex-1 p-4 md:p-5 border border-gray-200 bg-tertiary">
                <div className="text-black text-xl md:text-2xl font-bold leading-[150%] w-full">
                  16+
                </div>
                <div className="text-black/80 text-xs md:text-sm font-medium leading-[150%] w-full">
                  Years of Experience
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="flex-1 w-full relative">
            <div className="border border-gray-200 overflow-hidden bg-white aspect-square lg:aspect-auto lg:h-[400px] relative">
              {/* Background decorative image */}
              <div className="absolute inset-0 flex items-center justify-center overflow-hidden">
                <img
                  src="https://api.builder.io/api/v1/image/assets/TEMP/f0b3982f84fd468d1f8c84b5a69bca54cfa31930?width=3120"
                  alt=""
                  className="w-full h-full object-cover opacity-50"
                />
              </div>
              
              {/* Main house image */}
              <img
                src="https://api.builder.io/api/v1/image/assets/TEMP/7c4c3362a445b5dcbdf98188fae394424a91abf8?width=1510"
                alt="Hand holding a miniature house model"
                className="relative w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


